<template>
  <div class="event-grid__wrapper">
    <div class="event-grid">
      <BCard
        v-for="event in eventList"
        :key="event.id"
        hover
        class="event-grid"
        :class="cardClass(event)"
        :title="event.eventName"
        @click="view(event.id)"
      >
        <template v-slot:header>
          <span
            class="event-grid__certification-status float-left"
            :class="`status__dot--${event.simpleStatus()}`"
          >
            <!-- {{ $t(`status_${event.status}`) }}<br /> -->
            {{ $t(`status_${event.simpleStatus()}`) }}&nbsp;
          </span>
        </template>

        <BCardText>
          <span class="event-grid__date-start">
            {{ duration(event.dateStart, event.dateEnd) }}
          </span>

          <span class="event-grid__city">
            {{ event.city }}
          </span>

          <div class="event-grid__applicant-name">
            Zgłaszający:
            {{ event.applicantName }}
          </div>

          <div>
            <span class="event-grid__created-on">
              Data złożenia wniosku:
              {{ event.createdOn | moment("YYYY-MM-DD") }}
            </span>
          </div>
          <div v-if="event.approvedByFullname">
            <span class="event-grid__approved-on">
              Ocenione:
              {{ event.approvedOn | moment("YYYY-MM-DD") }}
            </span>
          </div>
        </BCardText>

        <template v-slot:footer>
          <div>
            <Btn
              v-if="event.canOpen(user) && event.isClosed()"
              icon="lock"
              class="float-left"
              size="sm"
              variant="link-white"
              tooltip="Odblokuj certyfikat"
              @click.stop="unlock(event.id)"
            />
            <Btn
              v-if="event.canClose(user) && !event.isClosed()"
              icon="unlock"
              class="float-left"
              size="sm"
              variant="link-white"
              tooltip="Zablokuj certyfikat"
              @click.stop="lock(event.id)"
            />
            <Btn
              v-if="event.canUploadProgramme(user)"
              icon="cloud-upload"
              size="sm"
              variant="link-white"
              tooltip="Wyślij program szczegółowy"
              @click.stop="uploadProgramme(event.id)"
            />
            <Btn
              v-if="event.canDelete(user)"
              icon="trash"
              class="float-left"
              size="sm"
              variant="link-white"
              tooltip="Usuń"
              @click.stop="remove(event.id, event.eventName)"
            />
            <Btn
              v-if="event.isCompliant(user)"
              icon="medal"
              size="sm"
              variant="link-white"
              tooltip="Pobierz certyfikat"
              @click.stop="getCertificate(event.certificateNo)"
            />
            <Btn
              v-if="event.canView(user)"
              icon="file-alt"
              size="sm"
              variant="link-white"
              tooltip="Zobacz"
              @click.stop="view(event.id)"
            />
            <Btn
              v-if="event.canEdit(user)"
              icon="pen"
              size="sm"
              variant="link-white"
              :tooltip="editButtonText"
              @click.stop="edit(event.id)"
            />
          </div>
        </template>
      </BCard>
    </div>
    <UploadModal
      v-model="uploadShow"
      :event-id="uploadEventId"
      @upload:success="reload"
    />
  </div>
</template>
<script>
import PublicEventResultsGrid from "./PublicEventResultsGrid";
import UserMixins from "./UserMixins";

export default {
  name: "UserEventResultsGrid",
  extends: PublicEventResultsGrid,
  mixins: [UserMixins],
  data() {
    return {
      editButtonText: "Zmień"
    };
  }
};
</script>
